var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsArray, IsDateString, IsNumber, IsObject, IsOptional, IsUUID } from 'class-validator';
import { CallFullSizeDto } from '../../calls/dto/call.full-size.dto.js';
import { ExerciseProgramFullSizeDto } from '../../exercise-programs/dtos/exercise-program.full-size.dto.js';
import { InvoiceFullSizeDto } from '../../invoice/index.js';
import { UserProfileDto } from '../../user/index.js';
import { OfficeProductAssignmentLineItemFullSizeDto } from './office-product-assignment-line-item.full-size.dto.js';
import { OfficeProductFullSizeDto } from './office-product.full-size.dto.js';
export class OfficeProductAssignmentFullSizeDto {
    id;
    createdAt;
    updatedAt;
    officeProduct;
    officeProductId;
    patient;
    patientId;
    therameVideoCallsCount = null;
    therameExerciseProgramsCount = null;
    therameVideoCallsCompleted = null;
    therameVideoCallsReserved = null;
    therameExerciseProgramsCreated = null;
    totalRemainingTaskCount = 0;
    connectedStripeAccount;
    connectedStripeAccountId;
    patientInvoiceId = null;
    patientInvoice = null;
    applicationFeeInvoiceId = null;
    applicationFeeInvoice = null;
    startedAt = null;
    activeUntil = null;
    // `Array<T>` erases to plain `Array` at runtime, which makes class-transformer
    // build empty elements — the element type has to be named directly
    calls;
    exercisePrograms;
    officeProductAssignmentLineItems;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], OfficeProductAssignmentFullSizeDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], OfficeProductAssignmentFullSizeDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], OfficeProductAssignmentFullSizeDto.prototype, "updatedAt", void 0);
__decorate([
    Expose(),
    IsObject(),
    Type(() => OfficeProductFullSizeDto),
    __metadata("design:type", OfficeProductFullSizeDto)
], OfficeProductAssignmentFullSizeDto.prototype, "officeProduct", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], OfficeProductAssignmentFullSizeDto.prototype, "officeProductId", void 0);
__decorate([
    Expose(),
    IsObject(),
    Type(() => UserProfileDto),
    __metadata("design:type", Function)
], OfficeProductAssignmentFullSizeDto.prototype, "patient", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], OfficeProductAssignmentFullSizeDto.prototype, "patientId", void 0);
__decorate([
    Expose(),
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Object)
], OfficeProductAssignmentFullSizeDto.prototype, "therameVideoCallsCount", void 0);
__decorate([
    Expose(),
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Object)
], OfficeProductAssignmentFullSizeDto.prototype, "therameExerciseProgramsCount", void 0);
__decorate([
    Expose(),
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Object)
], OfficeProductAssignmentFullSizeDto.prototype, "therameVideoCallsCompleted", void 0);
__decorate([
    Expose(),
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Object)
], OfficeProductAssignmentFullSizeDto.prototype, "therameVideoCallsReserved", void 0);
__decorate([
    Expose(),
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Object)
], OfficeProductAssignmentFullSizeDto.prototype, "therameExerciseProgramsCreated", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], OfficeProductAssignmentFullSizeDto.prototype, "totalRemainingTaskCount", void 0);
__decorate([
    Expose(),
    IsObject(),
    __metadata("design:type", Function)
], OfficeProductAssignmentFullSizeDto.prototype, "connectedStripeAccount", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], OfficeProductAssignmentFullSizeDto.prototype, "connectedStripeAccountId", void 0);
__decorate([
    IsUUID(),
    Exclude(),
    __metadata("design:type", Object)
], OfficeProductAssignmentFullSizeDto.prototype, "patientInvoiceId", void 0);
__decorate([
    Expose(),
    IsObject(),
    Type(() => InvoiceFullSizeDto),
    __metadata("design:type", Object)
], OfficeProductAssignmentFullSizeDto.prototype, "patientInvoice", void 0);
__decorate([
    IsUUID(),
    Exclude(),
    __metadata("design:type", Object)
], OfficeProductAssignmentFullSizeDto.prototype, "applicationFeeInvoiceId", void 0);
__decorate([
    Expose(),
    IsObject(),
    Type(() => InvoiceFullSizeDto),
    __metadata("design:type", Object)
], OfficeProductAssignmentFullSizeDto.prototype, "applicationFeeInvoice", void 0);
__decorate([
    IsDateString(),
    Expose(),
    IsOptional(),
    __metadata("design:type", Object)
], OfficeProductAssignmentFullSizeDto.prototype, "startedAt", void 0);
__decorate([
    IsDateString(),
    Expose(),
    IsOptional(),
    __metadata("design:type", Object)
], OfficeProductAssignmentFullSizeDto.prototype, "activeUntil", void 0);
__decorate([
    Expose(),
    IsArray(),
    Type(() => CallFullSizeDto),
    __metadata("design:type", Array)
], OfficeProductAssignmentFullSizeDto.prototype, "calls", void 0);
__decorate([
    Expose(),
    IsArray(),
    Type(() => ExerciseProgramFullSizeDto),
    __metadata("design:type", Array)
], OfficeProductAssignmentFullSizeDto.prototype, "exercisePrograms", void 0);
__decorate([
    Expose(),
    IsArray(),
    Type(() => OfficeProductAssignmentLineItemFullSizeDto),
    __metadata("design:type", Array)
], OfficeProductAssignmentFullSizeDto.prototype, "officeProductAssignmentLineItems", void 0);
//# sourceMappingURL=office-product-assignment.full-size.dto.js.map